import React from 'react';

const Home = () => {
    return ( 
        <main>
            <h1>Strona główna</h1>
        </main>
     );
}
 
export default Home;